import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

function applyBackground(bgId) {
  if (typeof document === "undefined") return;
  const cls = document.body.classList;
  Array.from(cls).forEach(c => { if (c.startsWith("bg-")) cls.remove(c); });
  cls.add(`bg-${bgId || "bg_default"}`);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionToken, setSessionToken] = useState(
    typeof window !== "undefined" ? localStorage.getItem("session_token") : null
  );

  const checkAuth = useCallback(async () => {
    try {
      const headers = {};
      const tok = localStorage.getItem("session_token");
      if (tok) headers.Authorization = `Bearer ${tok}`;
      const r = await api.get("/auth/me", { headers });
      setUser(r.data);
      applyBackground(r.data?.active_background);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("session_token");
    setSessionToken(null);
    setUser(null);
  };

  const setAuth = (u, tok) => {
    setUser(u);
    applyBackground(u?.active_background);
    if (tok) {
      localStorage.setItem("session_token", tok);
      setSessionToken(tok);
    }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, setUser: (u) => { setUser(u); if (u) applyBackground(typeof u === 'function' ? undefined : u?.active_background); }, setAuth, logout, sessionToken, refresh: checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
